import Application from "@ember/application";
import setupInspector from "@embroider/legacy-inspector-support/ember-source-4.12";
import compatModules from "@embroider/virtual/compat-modules";
import "@warp-drive/ember/install";
import { setBuildURLConfig } from "@warp-drive/utilities";
import { extendResolver } from "ember-can";
import { setMessages } from "ember-changeset-validations";
import loadInitializers from "ember-load-initializers";
import Resolver from "ember-resolver";
import runtimeEnvironment from "parog-web/utils/runtime-environment";
import validationMessages from "parog-web/validations/messages";
import ControlTower from "wise-control-tower";
import ENV from "./config/environment";
import "./deprecation-workflow";
import "../config/tailwind/input.css";

setBuildURLConfig({
  host: "/",
  namespace: "api/v2"
});

// ControlTower is only active in a prod build
if (ENV.environment == "production") {
  ControlTower.initialize({
    environment: runtimeEnvironment(),
    sentryOptions: {
      dsn: `https://de9611e93cd90d858ca93a56d687c1cf@sentry.public.semeia.io/7`,
      release: ENV.APP["version"] as string
    }
  });
}

export default class App extends Application {
  inspector = setupInspector(this);
  modulePrefix = ENV.modulePrefix;
  podModulePrefix = ENV.podModulePrefix;
  override Resolver = extendResolver(Resolver.withModules(compatModules));
}

loadInitializers(App, ENV.modulePrefix, compatModules);
setMessages(validationMessages);
